import React from 'react';

const AgentInfo = ({ ime, pozicija, telefon, email, isVisible }) => {
  return (
    <div
      className={`bg-gray-800 text-white rounded-lg shadow-lg p-4 transform border-2 border-pink-600 shadow-[0_0_10px_5px_rgba(225,0,85,0.7)] transition-opacity duration-300 ${
        isVisible ? 'opacity-100 translate-y-4' : 'opacity-0 translate-y-0'
      }`}
      style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: '1rem' }}
    >
      <h3 className="text-lg font-bold text-pink-600">{ime}</h3>
      <p className="text-sm text-gray-300">Pozicija: {pozicija}</p>
      <p className="text-sm text-gray-300">Telefon: {telefon}</p>
      <p className="text-sm text-gray-300">Email: {email}</p>
    </div>
  );
};

export default AgentInfo;
